import React from 'react'
import Box from '@mui/material/Box'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from '@mui/styles'
import SubjectRoundedIcon from '@mui/icons-material/SubjectRounded'

import FieldRowWrapper from '../FieldRowWrapper/FieldRowWrapper'
import { observer } from 'mobx-react'
import RawHtml from 'stories/components/RawHtml'

const useStyles = makeStyles((theme) => ({
  htmlContainer: {
    width: '100%',
    '& iframe, & > *': {
      width: ({ config }) => (config && config.width) || '100%',
      height: ({ config }) => (config && config.height) || '300px',
    },
  },
}))

function OEmbedContent({
  config,
  oembed,
  label,
  touched,
  error,
  description,
  url,
  ...props
}) {
  const classes = useStyles({ config })
  const classNames = {
    'formz-text-input': true,
    'formz-has-error': error,
    'full-width': props.fullWidth,
  }
  const embeddedContent = url && oembed && oembed.html
  return (
    <FieldRowWrapper
      className={classNames}
      error={error}
      touched={touched ? touched.toString() : undefined}
    >
      <label className="formz-field-and-label-holder">
        <div className="formz-input-title">{label}</div>
        <RawHtml
          className="formz-field-description"
          style={{ width: '100%' }}
          content={description || ''}
        />
        {embeddedContent ? (
          <RawHtml
            className={classes.htmlContainer}
            content={embeddedContent}
          />
        ) : (
          <Box
            my={1}
            align="center"
            display="flex"
            alignItems="center"
            justifyContent="center"
            className="formz-video-input-placeholder"
            width="100%"
          >
            <SubjectRoundedIcon />
            <Box mx={0.5}>
              <FormattedMessage id="pages.formMaker.section.editFieldSettings.fields.oEmbed.placeholder" />
            </Box>
          </Box>
        )}
      </label>
    </FieldRowWrapper>
  )
}

class OEmbed extends React.Component {
  render() {
    return <OEmbedContent {...this.props} />
  }
}

export default observer(OEmbed)
